import type { IntlShape } from 'react-intl';

import { downloadTicketAttachment } from '~/api/tickets';
import { showToast } from '~/components/Shared/EcToast/showToast';
import { IntakeFormFile } from '~/types/IntakeFormFile';
import * as toastTypes from '~/types/toast.types';
import { downloadFile } from '~/utils/files';

import { getFullIntakeFormFileName } from './getFullIntakeFormFileName';

export function downloadTicketFileAttachment(
  file: IntakeFormFile,
  intl: IntlShape,
) {
  const fileName = getFullIntakeFormFileName(file);

  downloadTicketAttachment(file.id)
    .then((downloadedFile) => {
      showToast(
        toastTypes.DOWNLOAD,
        intl.formatMessage(
          {
            id: 'DownloadTicketFileAttachment.downloadSuccess',
            defaultMessage: '{fileName} successfully downloaded.',
            description:
              'Success message when file attachment is downloaded. Example: fileName = "Document Name"',
          },
          { fileName },
        ),
      );
      downloadFile(downloadedFile, fileName);
    })
    .catch(() =>
      showToast(
        toastTypes.ERROR,
        intl.formatMessage({
          id: 'DownloadTicketFileAttachment.downloadError',
          defaultMessage: 'Download attachment failed. Please try again.',
          description: 'Error message when file attachment download fails',
        }),
      ),
    );
}
